<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle" v-if="IsAdd">烟囱设备添加</div>
          <div class="listtitle" v-if="IsEdit && !IsAdd">烟囱设备编辑</div>
          <div class="listtitle" v-if="!IsEdit && !IsAdd">烟囱设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-form-item
        label="设备名称"
        prop="equipmentName"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.equipmentName"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="设备编号"
        prop="equipmentNo"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.equipmentNo"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>

      <el-form-item label="附近设备" prop="equipmentNear">
        <el-input
          style="width: 50rem"
          v-model="ruleForm.equipmentNear"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="区域" prop="areaCode" style="display: inline-block">
        <el-select
          v-model="ruleForm.areaCode"
          placeholder="请选择"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
        >
          <el-option
            v-for="item in areaData"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="IP地址" prop="equipmentIp" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="ruleForm.equipmentIp"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="端口号" prop="equipmentPort" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="ruleForm.equipmentPort"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="通道号" prop="channelNo" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="ruleForm.channelNo"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="经度" prop="longitude" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="ruleForm.longitude"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="latitude" style="display: inline-block">
        <el-input
          style="width: 45rem"
          v-model="ruleForm.latitude"
          v-bind:disabled="!IsEdit"
        ></el-input>
        <ZjLngLatSelect
          :point_lat="ruleForm.latitude"
          :point_lng="ruleForm.longitude"
          style="margin-left: 0.5rem"
          @onGotLngLat="onGotLngLat"
        ></ZjLngLatSelect>
      </el-form-item>
      <el-form-item
        label="RTSP"
        prop="streamUrl"
        style="display: inline-block"
      >
        <el-input
          style="width: 50rem"
          v-model="ruleForm.streamUrl"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="密度间值"
        prop="extra"
        style="display: inline-block"
      >
        <el-input
          style="width: 50rem"
          v-model="ruleForm.extra"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>

      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getEquipmentById, addEquipment, updateEquipment, listEquipmentArea } from "@/api/src/equipment";

export default {
  name: "ChimneyEquipInfo",
  controller: "UI",
  action: "ChimneyEquipInfo",
  props: {
    query: {
      InfoId: String,
      type: String,
    },
  },
  data() {
    return {
      ruleForm: {
        id: null,
        equipmentName: "",
        categoryCode: "chimney",
        areaCode: null,
        longitude: null,
        latitude: null,
        equipmentNo: null,
        equipmentNear: null,
        equipmentIp: null,
        equipmentPort: null,
        channelNo: null,
        streamUrl: null,
        extra: null,
      },
      rules: {
        equipmentName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
      },
      IsEdit: false,
      IsAdd: false,
      areaData: [],
    };
  },
  created: function () {
    if (this.$route.query.id) {
      this.search();
    }
    if (this.$route.query.type == "look") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    if (this.$route.query.type == "add") {
      this.IsAdd = true;
    } else {
      this.IsAdd = false;
    }
    this.loadAreas();
  },
  mounted: function () {},
  watch: {
    $route: function () {
      if (this.$route.query.id) {
        this.search();
      }
    },
  },
  methods: {
    loadAreas() {
      listEquipmentArea({ pageNum: 1, pageSize: 999 })
        .then((r) => {
          this.areaData = r.data || [];
        })
        .catch((e) => {
          console.log(e);
        });
    },
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      let id = this.$route.query.id;
      if (id) {
        getEquipmentById(id)
          .then((r) => {
            let data = r.data;
            this.ruleForm.id = data.id;
            this.ruleForm.equipmentName = data.equipmentName;
            this.ruleForm.categoryCode = data.categoryCode;
            this.ruleForm.areaCode = data.areaCode;
            this.ruleForm.longitude = data.longitude;
            this.ruleForm.latitude = data.latitude;
            this.ruleForm.equipmentNo = data.equipmentNo;
            this.ruleForm.equipmentNear = data.equipmentNear;
            this.ruleForm.equipmentIp = data.equipmentIp;
            this.ruleForm.equipmentPort = data.equipmentPort;
            this.ruleForm.channelNo = data.channelNo;
            this.ruleForm.streamUrl = data.streamUrl;
            this.ruleForm.extra = data.extra;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg("服务异常，请联系管理员！");
          });
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.latitude = obj.lat;
      this.ruleForm.longitude = obj.lng;
    },
    onBack() {
      this.$router.go(-1);
    },
    save() {
      this.saveData();
    },
    saveData() {
      if (this.ruleForm.longitude != null) {
        this.ruleForm.longitude = Number(this.ruleForm.longitude);
      }
      if (this.ruleForm.latitude != null) {
        this.ruleForm.latitude = Number(this.ruleForm.latitude);
      }
      this.ruleForm.categoryCode = "chimney";
      if (this.$route.query.type == "edit") {
        updateEquipment(this.ruleForm)
          .then((r) => {
            if (r.code === 200) {
              this.$message({
                type: "success",
                message: "保存成功！",
              });
              this.logInfo.ActionName = "烟囱设备修改";
              this.logInfo.LogMessage = "烟囱设备修改";
              this.logInfo.ModuleName = "烟囱监测";
              this.logInfo.PageName = "烟囱设备管理详情";
              this.addOperationLog();
            } else {
              this.$message({
                type: "error",
                message: r.data.msg || "保存失败！",
              });
            }
            this.$router.go(-1);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg("服务异常，请联系管理员！");
          });
      } else {
        addEquipment(this.ruleForm)
          .then((r) => {
            if (r.code === 200) {
              this.$message({
                type: "success",
                message: "保存成功！",
              });
              this.logInfo.ActionName = "烟囱设备添加";
              this.logInfo.LogMessage = "烟囱设备添加";
              this.logInfo.ModuleName = "烟囱监测";
              this.logInfo.PageName = "烟囱设备管理详情";
              this.addOperationLog();
            } else {
              this.$message({
                type: "error",
                message: r.data.msg || "保存失败！",
              });
            }
            this.$router.go(-1);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg("服务异常，请联系管理员！");
          });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style type="text/css"></style>
